import { useState } from 'react';
import { alpha } from '@mui/material/styles';
import { Box, Divider, Typography, MenuItem, Avatar, IconButton, Popover, Chip } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { getCurrentIdentity } from '../../../protectedRoute';

export default function AccountPopover() {
  const [open, setOpen] = useState(null);
  const navigate = useNavigate();
  // Identidad real: empleado logueado o admin
  const identity = getCurrentIdentity();

  const handleOpen = (event) => {
    setOpen(event.currentTarget);
  };

  const handleClose = () => {
    setOpen(null);
  };

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('employee');
    localStorage.removeItem('adminEmail');
    navigate('/login');
    setOpen(null);
  };

  return (
    <>
      <IconButton
        onClick={handleOpen}
        sx={{
          p: 0.5,
          borderRadius: 1.5,
          border: (theme) => `1px solid ${theme.palette.divider}`,
          ...(open && {
            bgcolor: (theme) => alpha(theme.palette.grey[500], 0.08),
          }),
        }}
      >
        <Avatar alt={identity.displayName} sx={{ width: 32, height: 32, bgcolor: 'primary.main' }}>
          {identity.displayName?.charAt(0)?.toUpperCase() || 'A'}
        </Avatar>
      </IconButton>

      <Popover
        open={Boolean(open)}
        anchorEl={open}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        PaperProps={{
          sx: {
            p: 1,
            mt: 1,
            width: 220,
          },
        }}
      >
        <Box sx={{ px: 1.5, py: 1 }}>
          <Typography variant="subtitle2" noWrap>
            {identity.displayName}
          </Typography>
          {identity.email && (
            <Typography variant="caption" sx={{ color: 'text.secondary' }} noWrap>
              {identity.email}
            </Typography>
          )}
          <Box sx={{ mt: 0.5 }}>
            <Chip label={identity.role} size="small" color={identity.role === 'Admin' ? 'primary' : 'default'} />
          </Box>
        </Box>

        <Divider sx={{ my: 0.5 }} />

        <MenuItem onClick={handleLogout} sx={{ color: 'error.main', fontWeight: 600 }}>
          Log out
        </MenuItem>
      </Popover>
    </>
  );
}
